import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import {
  Agenda,
  AgendaDetail,
  Beranda,
  Berita,
  BeritaDetail,
  Galeri,
  LokasiPelayanan,
  Kontak,
  Pejabat,
  StrukturOrganisasi,
  StrukturPPID,
  VisiMisi,
  Laporanppid,
  JPbphtb,
  JPpbb,
  JPrestoran,
  Photel,
  Phiburan,
  Preklame,
  Pairtanah,
  Pparkir,
  Pppj,
  ProdukHukum,
  ProdukHukumDetail,
  ProdukHukumJenis,
  BeritaVideo,
  DokumenPerencanaan,
  Cektunggakan,
} from "./pages";

import {
  Dashboard,
  KelolaAgenda,
  KelolaApbd,
  KelolaBanner,
  KelolaBerita,
  KelolaBidang,
  KelolaGaleri,
  KelolaInfografis,
  KelolaJabatan,
  KelolaPad,
  KelolaPajak,
  KelolaPejabat,
  KelolaRetribusi,
  KelolaUser,
  Login,
  KelolaProdukHukum,
  KelolaLaporanPpid,
  KelolaBeritaVideo,
  KelolaDokumenPerencanaan,
} from "./pages/Admin";

import useToken from "./assets/utils/useToken";


function ProtectedRoute({ isAllowed, redirectTo = "/admin/login", children }) {
  return isAllowed ? children : <Navigate to={redirectTo} replace />;
}

function App() {
  const { token, setToken } = useToken();
  const role = localStorage.getItem("role");

const isLoggedIn = !!token?.token;
  const isSuperAdmin = isLoggedIn && role === "superadmin";

  return (
    <Router basename="/">
      <div className="App">
        <Routes>

          {/* PUBLIC */}
          <Route path="/" element={<Beranda />} />
          <Route path="/visimisi" element={<VisiMisi />} />
          <Route path="/struktur-organisasi" element={<StrukturOrganisasi />} />
          <Route path="/StrukturPPID" element={<StrukturPPID />} />
          <Route path="/JPbphtb" element={<JPbphtb />} />
          <Route path="/JPpbb" element={<JPpbb />} />
          <Route path="/JPrestoran" element={<JPrestoran />} />
          <Route path="/Photel" element={<Photel />} />
          <Route path="/Phiburan" element={<Phiburan />} />
          <Route path="/Preklame" element={<Preklame />} />
          <Route path="/Pairtanah" element={<Pairtanah />} />
          <Route path="/Pparkir" element={<Pparkir />} />
          <Route path="/Pppj" element={<Pppj />} />
          <Route path="/berita" element={<Berita />} />
          <Route path="/berita-detail/:id" element={<BeritaDetail />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/agenda-detail/:id" element={<AgendaDetail />} />
          <Route path="/galeri" element={<Galeri />} />
          <Route path="/lokasi-pelayanan" element={<LokasiPelayanan />} />
          <Route path="/pejabat" element={<Pejabat />} />
          <Route path="/kontak" element={<Kontak />} />
          <Route path="/Laporanppid" element={<Laporanppid />} />
          <Route path="/berita-video" element={<BeritaVideo />} />
          <Route path="/dokumen-perencanaan" element={<DokumenPerencanaan />} />
          <Route path="/ProdukHukum" element={<ProdukHukum />} />
          <Route path="/produk-hukum/:kategori" element={<ProdukHukumJenis />} />
          <Route path="/produk-hukum/:kategori/:id" element={<ProdukHukumDetail />} />
          <Route path="/Cektunggakan" element={<Cektunggakan />} />

          {/* ADMIN // 🔥 ROOT ADMIN → redirect ke dashboard */}
        
<Route
  path="/admin"
  element={<Navigate to="/admin/dashboard" replace />}
/>

 {/*// 🔥 LOGIN */}
<Route
  path="/admin/login"
  element={
    isLoggedIn
      ? <Navigate to="/admin/dashboard" replace />
      : <Login setToken={setToken} />
  }
/>

 {/* // 🔥 DASHBOARD (PROTECTED) */}
<Route
  path="/admin/dashboard"
  element={
    <ProtectedRoute isAllowed={isLoggedIn}>
      <Dashboard setToken={setToken} />
    </ProtectedRoute>
  }
/>

          {/* ADMIN (LOGIN REQUIRED) */}
          <Route
            path="/admin/kelola-berita"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaBerita setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-agenda"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaAgenda setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-galeri"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaGaleri setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-infografis"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaInfografis setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-pajak"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaPajak setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-retribusi"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaRetribusi setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-apbd"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaApbd setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-pad"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaPad setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-pejabat"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaPejabat setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-jabatan"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaJabatan setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-bidang"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaBidang setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-banner"
            element={
              <ProtectedRoute isAllowed={isLoggedIn}>
                <KelolaBanner setToken={setToken} />
              </ProtectedRoute>
            }
          />

          {/* SUPERADMIN */}
          <Route
            path="/admin/kelola-produk-hukum"
            element={
              <ProtectedRoute isAllowed={isSuperAdmin}>
                <KelolaProdukHukum setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-laporan-ppid"
            element={
              <ProtectedRoute isAllowed={isSuperAdmin}>
                <KelolaLaporanPpid setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-berita-video"
            element={
              <ProtectedRoute isAllowed={isSuperAdmin}>
                <KelolaBeritaVideo setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-dokumen-perencanaan"
            element={
              <ProtectedRoute isAllowed={isSuperAdmin}>
                <KelolaDokumenPerencanaan setToken={setToken} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/kelola-user"
            element={
              <ProtectedRoute isAllowed={isSuperAdmin}>
                <KelolaUser setToken={setToken} />
              </ProtectedRoute>
            }
          />

        </Routes>
      </div>
    </Router>
  );
}

export default App;